module.exports = __webpack_public_path__ + "static/media/arm.664ba826.png";